import {
  addMemberViolation,
  getViolationsByMemberId,
} from "../../../../Redux/Violation/ViolationActions";
import validator, { ValidationField } from "../../../../Util/validator";
import { AppDispatch, RootState } from "../../../../Redux/store";
import imageUrlHelper from "../../../../Util/imageUrlHelper";
import imageToBase64 from "../../../../Util/imageToBase64";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../Common/Loading/Loading";
import styles from "./AddViolation.module.scss";
import React, { useRef, useState } from "react";
import { CiImageOn } from "react-icons/ci";
import { IoClose } from "react-icons/io5";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  memberId: string;
}

function AddViolation(props: Props) {
  const dispatch = useDispatch<AppDispatch>();
  const { setIsOpen, memberId } = props;
  const { addMemberViolationLoading } = useSelector(
    (state: RootState) => state.violations,
  );
  const imageRef = useRef<HTMLInputElement>(null);
  const [description, setDescription] = useState("");
  const [score, setScore] = useState("");
  const [image, setImage] = useState<File | string | null>(null);
  const [errors, setErrors] = useState({
    description: "",
    score: "",
  });

  const addViolationHandler = async () => {
    const fieldsArray = [
      {
        key: "description",
        value: description,
        type: "text",
      },
      {
        key: "score",
        value: score,
        type: "numberOnly",
      },
    ];

    const { errors: fieldsErrors, isValid } = validator(
      fieldsArray as ValidationField[],
    );

    setErrors({
      ...errors,
      ...fieldsErrors,
    });

    if (!isValid || addMemberViolationLoading) {
      return;
    }

    const successHandler = () => {
      setIsOpen(false);
      dispatch(getViolationsByMemberId({ memberId: Number(memberId) }));
    };

    const imagebase64 = await imageToBase64(image);

    dispatch(
      addMemberViolation({
        memberId: Number(memberId),
        description,
        score: Number(score),
        image: imagebase64,
        successHandler,
      }),
    );
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.headingContainer}>
        <h1 className={styles.heading}>Add Violation</h1>
      </div>
      <form className={styles.formContainer}>
        <div className={styles.textAreaContainer}>
          <p className={styles.label}>Description</p>
          <textarea
            className={styles.textArea}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={4}
          />
          <p className={styles.error}>{errors.description}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Score</p>
          <input
            type="text"
            className={styles.input}
            value={score}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) {
                const num = Number(value);
                if (value === "" || num <= 30) {
                  setScore(value);
                }
              }
            }}
            maxLength={2}
            inputMode="numeric"
          />
    
          <p className={styles.error}>{errors.score}</p>
        </div>
        <div className={styles.imageInputContainer}>
          <p className={styles.label}>Image (Optional)</p>
          <input
            className={styles.imageInput}
            type="file"
            hidden
            ref={imageRef}
            accept="image/*"
            value={""}
            onChange={(e) => setImage(e.target.files?.[0] || null)}
          />
          {image ? (
            <div className={styles.inputImageContainer}>
              <img
                className={styles.inputImage}
                src={imageUrlHelper(image)}
                alt="Violation"
              />
              <div className={styles.iconContainer}>
                <IoClose
                  className={styles.icon}
                  onClick={() => setImage(null)}
                />
              </div>
            </div>
          ) : (
            <div
              className={styles.imageInputBox}
              onClick={() => imageRef.current?.click()}
            >
              <div className={styles.iconContainer}>
                <CiImageOn className={styles.icon} />
              </div>
              <div className={styles.labelContainer}>
                <p className={styles.label}>Upload Image</p>
              </div>
            </div>
          )}
        </div>
        {addMemberViolationLoading && <Loading />}
      </form>

      <div className={styles.buttonContainer}>
        <button className={styles.button} onClick={addViolationHandler}>
          Add
        </button>
        <button className={styles.cancelBtn} onClick={() => setIsOpen(false)}>
          Cancel
        </button>
      </div>
    </div>
  );
}

export default AddViolation;
